import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './context/AuthContext';
import './config/configureAnnouncements';
import './styles.css';
import './modal-layout.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <HashRouter>
        <AuthProvider><App /></AuthProvider>
      </HashRouter>
    </ErrorBoundary>
  </StrictMode>,
);
